import debounce from 'lodash/debounce'

export const MAX_TIMEOUT_MS = 2147483647 // about 24.8 days
export const SIGNOUT_URL = '/account/signout'

export default function initIdleLogout(account) {
  let timeout = account?.idletimeout ? account.idletimeout : null

  if (!timeout) return

  let timer
  const idleLogoutTimeout = Math.min(1000 * timeout, MAX_TIMEOUT_MS)
  const debounceDuration = 200
  const debounceReset = debounce(doClear, debounceDuration)

  doClear()
  window.addEventListener('load', debounceReset)
  window.addEventListener('mousemove', debounceReset, true)
  window.addEventListener('mousedown', debounceReset, true)
  window.addEventListener('touchstart', debounceReset, true)
  window.addEventListener('click', debounceReset, true)
  window.addEventListener('keydown', debounceReset, true)
  window.addEventListener('scroll', debounceReset, true)

  function signOut() {
    window.location.href = SIGNOUT_URL
  }

  function doClear() {
    clearTimeout(timer)
    timer = setTimeout(signOut, idleLogoutTimeout)
  }
}
